const ImageSize = 3145728;

export function isQuillContentEmpty(html) {
  if (!html) return true;

  // Remove all HTML tags
  const text = html.replace(/<[^>]*>/g, '');

  // Decode common HTML entities like &nbsp;
  const decoded = text
    .replace(/&nbsp;/gi, ' ')
    .replace(/&zwnj;|&zwj;|&lrm;|&rlm;/gi, '');

  // Trim whitespace (including newlines, tabs)
  const cleaned = decoded.trim();

  return cleaned.length === 0;
}
export const offerImageValidations = [
  {
    validationFn : (file) => {
      return file.size < ImageSize;
    },
    error: "Maximum file size is 3 MB"
  }
]

export const MediaKeys = {
    LOGO: "logo",
    MEDIA: "media",
    EXTRA_MEDIA: "additional_media",
    BANNER_LOGO: "banner_logo",
    EVENT_BANNER: "event_banner",
    EVENT_THUMBNAIL: "event_thumbnail",
};
